export default "__VITE_ASSET__9HxLt3kr__"